import React from 'react';
import { Subject } from "rxjs";
import { FormPane } from "../../components/FormZero/PageComponents/FormPane/FormPane";
import axios from "axios";
import { Button } from "../../components/FormZero/Button/Button";
import { Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, ThemeProvider, createTheme, Unstable_Grid2 as Grid, Box, Stack, Paper, Typography } from "@mui/material";
import { ActionPanel } from "../../components/FormZero/ActionPanel/ActionPanel";
import * as XLSX from "xlsx";
import Chip from '@mui/material/Chip';
import { EACH_LOOKUP_TABLE } from "../CommonInfo";
import { Checkbox, List, ListItem, ListItemButton, ListItemIcon, ListItemText, TextField } from "@mui/material";
import {
    DataGridPro,
    useGridApiRef,
    gridVisibleRowsLookupSelector,
    DataGridProProps
} from "@mui/x-data-grid-pro";
import { ISearchChips } from '../../interfaces/Core/ISearchChips';
import SearchChips from '../../components/SearchChips';
import ActionMenu from '../../components/ActionMenu';
import ActionButton from '../../components/ActionButton';
import { IDeliveryHeader } from '../../interfaces/Logistics/IDeliveryHeader';
import { IDeliveryItem } from '../../interfaces/Logistics/IDeliveryItem';
import moment from 'moment';
import CheckIcon from '@mui/icons-material/FactCheck';
import CloseIcon from '@mui/icons-material/CloseRounded';

// https://codesandbox.io/s/19r60?file=/src/ExpandableRowTable.js

function PanelView(props: { dataSource?: any[] | undefined; selectedDeliveries: any; setSelectedDeliveries: any; selectionModel?: any[] | undefined; requestUpdate: any; }) {
    const { dataSource = [], selectedDeliveries, setSelectedDeliveries, selectionModel = [], requestUpdate } = props;
    const [showDownloadDialog, setShowDownloadDialog] = React.useState(false);
    const [showStatusDialog, setShowStatusDialog] = React.useState(false);

    const [downloadDataSource, setDownloadDataSource] = React.useState<any>([]);
    React.useEffect(() => {
        let downloadBaseList = [];
        if (selectionModel.length === 0) {
            downloadBaseList = dataSource;
        }
        else {
            let l = dataSource.filter((row: { id: any; }) => selectionModel.indexOf(row.id) > -1);
            downloadBaseList = l;
        }
        setDownloadDataSource(downloadBaseList);
    }, [selectionModel, dataSource]);

    function downloadXLSX() {
        let downloadBaseList = [];
        downloadBaseList = downloadDataSource.filter((item: { submitted_at: null; }) => {
            if (item.submitted_at === null) {
                return notSubmitted;
            }
            else {
                return checked.indexOf(item.submitted_at) > -1
            }
        })

        let r = [...downloadBaseList].map(r => {
            delete r['id'];
            return r;
        });
        console.log(r);

        const ws = XLSX.utils.json_to_sheet(r);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Export');

        XLSX.writeFile(wb, "Invoice.xls"); // <-- just do it this way.
    }

    function downloadXMLFile() {
        // create xml file from [...dataSource] and download it.
        let downloadBaseList = [];
        downloadBaseList = downloadDataSource.filter((item: { submitted_at: null; }) => {
            if (item.submitted_at === null) {
                return notSubmitted;
            }
            else {
                return checked.indexOf(item.submitted_at) > -1
            }
        })

        let r = [...downloadBaseList].map(r => {
            delete r['id'];
            return r;
        });

        r.map(r => {
            let xml = "<row>";
            for (let key in r) {
                xml += "<" + key + ">" + r[key] + "</" + key + ">";
            }
            xml += "</row>";
            return xml;
        }).join("\n");
        let xml = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<rows>\n" + r + "\n</rows>";
        let blob = new Blob([xml], { type: "text/xml" });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "Invoices.xml";
        a.click();

    }

    const confirmSettingSubmitted = async function () {
        try {
            await axios.put("logistic/shippedDeliveries", {
                list: selectedDeliveries,
                field: 'submitted',
                value: true
            });
            await axios.put("logistic/shippedDeliveries", {
                list: selectedDeliveries,
                field: 'submitted_at',
                value: new Date().toLocaleDateString()
            });
            await requestUpdate();
            setSelectedDeliveries([]);
            setShowStatusDialog(false);
        }
        catch (e) {
            console.log(e);
        }
    };

    const [checked, setChecked] = React.useState<any>([]);
    const handleToggle = (value: any) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const [notSubmitted, setNotSubmitted] = React.useState(false);

    return (
        <>
            <div className="SprayRecordsGrid_PanelView">
                <div className="row">
                    <div className="col-6">
                        <Button fullWidth={true} className="button-square" clickHandler={() => setShowDownloadDialog(true)} text={"Download Report"} />
                        {(showDownloadDialog) && (
                            <Dialog
                                open={true}
                                onClose={() => setShowDownloadDialog(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                                    Download Report
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Click Download to Download Invoice Report
                                    </DialogContentText>
                                    <List sx={{}} dense component="div" role="list"
                                    >
                                        {[...dataSource.reduce((set: any, item: { submitted_at: any; }) => {
                                            let local = new Set([...set]);
                                            local.add(item.submitted_at);
                                            return local;
                                        }, new Set())].filter(x => x !== null).map((value) => {
                                            const labelId = `transfer-list-all-item-${value}-label`;
                                            return (
                                                <ListItem
                                                    key={value.id}
                                                    role="listitem"
                                                >
                                                    <ListItemButton role={undefined} onClick={handleToggle(value)} dense>
                                                        <ListItemIcon>
                                                            <Checkbox
                                                                edge="start"
                                                                checked={checked.indexOf(value) !== -1}
                                                                tabIndex={-1}
                                                                disableRipple
                                                                inputProps={{ 'aria-labelledby': labelId }}
                                                            />
                                                        </ListItemIcon>
                                                        <ListItemText id={labelId} primary={`${value}`} />&nbsp;
                                                    </ListItemButton>
                                                </ListItem>
                                            );
                                        })}
                                        <ListItem>
                                            <ListItemButton role={undefined} onClick={() => setNotSubmitted(!notSubmitted)} dense>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={notSubmitted}
                                                        tabIndex={-1}
                                                        disableRipple
                                                    // inputProps={{ 'aria-labelledby': labelId }}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText primary={`Not Submitted`} />&nbsp;
                                            </ListItemButton>
                                        </ListItem>
                                    </List>
                                    {/*<pre>{JSON.stringify(checked)}</pre>*/}
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => downloadXLSX()} autoFocus text={"Download Excel"} fullWidth={true} />
                                    <Button onClick={() => downloadXMLFile()} autoFocus text={"Download XML"} fullWidth={true} />
                                    <Button onClick={() => setShowDownloadDialog(false)} autoFocus text={"Close"} fullWidth={true} />
                                </DialogActions>
                            </Dialog>
                        )}
                    </div>
                    <div className="col-6">
                        <Button fullWidth={true} className="button-square" clickHandler={() => setShowStatusDialog(true)} text={"Update Status"} />
                        {(showStatusDialog) && (
                            <Dialog
                                open={true}
                                onClose={() => setShowDownloadDialog(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                                    Are you sure?
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        You are about to mark {selectedDeliveries.length} deliveries as submitted to Web Track. Would you like to continue?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => confirmSettingSubmitted()} autoFocus text={"Yes"} fullWidth={true} />
                                    <Button onClick={() => setShowStatusDialog(false)} text={"No"} fullWidth={true} />
                                </DialogActions>
                            </Dialog>
                        )}
                    </div>
                </div>

            </div>
        </>
    )
}


export function Invoices(props: any) {
    // const { } = props;

    // const [visibleRows, setVisibleRows] = React.useState<any>();
    // const apiRef = useGridApiRef();

    // console.log("visibleRows", visibleRows); // Only render when the visible columns changes.

    // React.useEffect(() => {
    //     apiRef.current.subscribeEvent("stateChange", () => {
    //         return setVisibleRows(gridVisibleRowsLookupSelector(apiRef.current.state));
    //     });
    // }, [apiRef]);

    // function getLocationDefaultTrayFreightCost(cellValues: { row: { current_load: { route: { locations: any[]; }; }; ShipToName: any; ShipToCity: any; ShipToState: any; }; }) {
    //     console.log(cellValues.row)
    //     try {
    //         let locations = cellValues.row.current_load.route.locations.filter((loc: { CustomerName: any; City: any; State: any; }) => {
    //             let res = (
    //                 loc.CustomerName === cellValues.row.ShipToName &&
    //                 loc.City === cellValues.row.ShipToCity &&
    //                 loc.State === cellValues.row.ShipToState
    //             )
    //             return res;
    //         });
    //         console.log(locations)
    //         if (locations.length === 1) {
    //             return locations[0].tray_freight_cost
    //         }
    //         return -1;
    //     } catch (e) {
    //         return -1;
    //     }
    // }

    // const columns: any = [
    //     {
    //         field: 'submitted', headerName: 'Web Track', width: 150, editable: false,
    //         renderCell: (cellValues: { row: { submitted: any; }; }) => {
    //             return (
    //                 <div>
    //                     <Chip label={cellValues.row.submitted ? "Submitted" : "Not Submitted"} style={{ backgroundColor: cellValues.row.submitted ? "green" : "black", width: '100%' }} />
    //                 </div>
    //             );
    //         }
    //     },
    //     { field: 'submittedAt', headerName: 'Submitted At', width: 200 },
    //     { field: 'status', headerName: 'Status', width: 200 },
    //     { field: 'deliveryHeaderId', headerName: 'Delivery #', width: 200 }, //BrokerDeliveryID?
    //     {
    //         field: "MaterialGroup_Type", headerName: 'Tray Type', width: 200,
    //         valueGetter: (cellParams: { row: { materialGroup: string | undefined; }; }) => {
    //             if (cellParams.row.materialGroup !== undefined) {
    //                 let svc = cellParams.row.materialGroup.substring(3);
    //                 return svc;
    //             }
    //             return "";
    //         }
    //     },
    //     {
    //         field: "MaterialGroup_Each", headerName: 'UOM - Each', width: 200,
    //         valueGetter: (cellParams: { row: { materialGroup: string | undefined; }; }) => {
    //             if (cellParams.row.materialGroup !== undefined) {
    //                 let svc = cellParams.row.materialGroup.substring(3);
    //                 return EACH_LOOKUP_TABLE[svc];
    //             }
    //             return "";
    //         }
    //     },
    //     { field: 'orderedQuantity', headerName: '# of Trays', width: 200 },
    //     {
    //         field: 'number_of_trays_sent', headerName: 'Shipped Trays', width: 200, editable: true,
    //         renderCell: (cellValues: { row: { number_of_trays: number; number_of_trays_sent: any; }; }) => {
    //             return (<span style={{ color: Math.abs(cellValues.row.number_of_trays - cellValues.row.number_of_trays_sent) > 0 ? "red" : "black" }} >{cellValues.row.number_of_trays_sent}</span>);
    //         }
    //     },
    //     { field: 'soldToName', headerName: 'Customer Name', width: 200 },
    //     { field: 'materialDescription', headerName: 'Description', width: 200 },
    //     { field: 'brokerMaterialNumber', headerName: 'Material Number', width: 200 },
    //     { field: 'shipMethodDesc', headerName: 'Planned Ship Type', width: 200 },
    //     {
    //         field: 'actualShipType', headerName: 'Ship Type', width: 200,
    //         renderCell: (cellValues: { row: { projected_ship_type: any; actual_ship_type: any; }; }) => {
    //             return (<span style={{ color: cellValues.row.projected_ship_type !== cellValues.row.actual_ship_type ? "red" : "black" }} >{cellValues.row.actual_ship_type}</span>);
    //         }
    //     },
    //     { field: 'boxCharge', headerName: 'Box Charge', width: 200 },
    //     {
    //         field: 'tray_freight_cost_default', headerName: 'Tray Freight Cost', width: 200,
    //         renderCell: (cellValues: any) => {
    //             let fc = getLocationDefaultTrayFreightCost(cellValues)
    //             return (<span>{fc}</span>);
    //         }
    //     },
    //     {
    //         field: 'tray_freight_cost', headerName: 'Adjusted TFC', width: 200,
    //         renderCell: (cellValues: any) => {
    //             let fc = getLocationDefaultTrayFreightCost(cellValues)
    //             return (<span style={{ color: cellValues.row.tray_freight_cost !== fc ? "red" : "black" }} >{cellValues.row.tray_freight_cost}</span>);
    //         }
    //     },
    //     {
    //         field: 'ship_cost', headerName: 'Planned Ship Cost', width: 200,
    //         valueGetter: (cellValues: any) => {
    //             console.log(cellValues);
    //             try {
    //                 return new Intl.NumberFormat('en-US', {
    //                     style: 'currency',
    //                     currency: 'USD'
    //                 }).format(getLocationDefaultTrayFreightCost(cellValues) * cellValues.row.OrderdQty)
    //             } catch (e) {
    //                 return new Intl.NumberFormat('en-US', {
    //                     style: 'currency',
    //                     currency: 'USD'
    //                 }).format(0);
    //             }
    //         }
    //     },
    //     {
    //         field: 'actual_ship_cost', headerName: 'Adjusted Ship Cost', width: 200,
    //         valueGetter: (cellValues: { row: { tray_freight_cost: number; OrderdQty: number; }; }) => {
    //             console.log(cellValues);
    //             try {
    //                 return new Intl.NumberFormat('en-US', {
    //                     style: 'currency',
    //                     currency: 'USD'
    //                 }).format(cellValues.row.tray_freight_cost * cellValues.row.OrderdQty)
    //             } catch (e) {
    //                 return new Intl.NumberFormat('en-US', {
    //                     style: 'currency',
    //                     currency: 'USD'
    //                 }).format(0);
    //             }
    //         }
    //     },
    // ];

    // const [unfilteredRows, setUnfilteredRows] = React.useState<any>([]);
    // const [rows, setRows] = React.useState([]);
    // const [filterFormData, setFilterFormData] = React.useState<any>({});
    // const formStructure = [
    //     {
    //         size: {
    //             default: 4
    //         },
    //         key: "week_year",
    //         type: "week-filter",
    //         label: "Week"
    //     },
    //     { key: "delivery_number", type: "text", size: { default: 4 }, label: "Delivery Number" }
    // ];
    // const formSubject = new Subject();
    // formSubject.subscribe((v) => {
    //     setFilterFormData(v);
    // });

    // const [selectionModel, setSelectionModel] = React.useState<any>([]);

    // const getFilteredLoads = async () => {
    //     if (filterFormData === undefined || filterFormData['week_year'] === null || filterFormData['week_year'] === undefined || filterFormData['week_year'] === null || filterFormData['week_year'] === "") {
    //         setRows([]);
    //         return;
    //     }

    //     console.log("GetListOfPatchingToBeDoneFromServer");
    //     try {

    //         let outputRows: any[] = [];
    //         await filterFormData['week_year'].forEachAsync(async (weekObj: { week: any; year: any; }) => {
    //             console.log(weekObj);
    //             // const [year, week] = weekObj.split("-");
    //             //`${process.env.REACT_APP_ENDPOINT}/api/Crews`
    //             //const response = await axios.get(`/logistic/shippedDeliveries/week/${weekObj.week}/${weekObj.year}`);
    //             const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/DeliveryHeaders/${weekObj.week}/${weekObj.year}`);
    //             if (response.status === 200) {
    //                 // TODO: refresh the table on the main page? or location.reload
    //                 console.log(response);
    //                 outputRows = [...outputRows, ...response.data]
    //             }
    //         });
    //         return outputRows;
    //     } catch (err) {
    //         console.log(err);
    //         return [];
    //     }
    // }

    // const loadLoads = async function () {
    //     try {
    //         let rows = await getFilteredLoads();
    //         let ro: any[] = [];
    //         if (rows) {
    //             let r = rows.filter(x => x.current_load !== undefined && x.current_load !== null && x.current_load.Shipped == 1);
    //             r.forEach(order => {
    //                 order.items.forEach((d: { id: any; }, index: any) => {
    //                     let item = { ...d, ...order, id: d.id };
    //                     ro.push(item);
    //                 })
    //             });
    //             setUnfilteredRows(ro)
    //         }

    //     }
    //     catch (e) {
    //         console.log(e);
    //     }
    // };

    // const total = React.useMemo(() => {
    //     if (visibleRows === undefined || visibleRows === null || Object.keys(visibleRows).length === 0) {
    //         let t = 0;
    //         rows.forEach((row: any) => {
    //             console.log(row)
    //             t += (row.tray_freight_cost * row.OrderdQty);
    //         })
    //         return t;
    //     }

    //     console.log(visibleRows);
    //     let t = 0;
    //     rows.forEach((row: any) => {
    //         console.log(row)
    //         if (visibleRows[row.id] !== undefined && visibleRows[row.id] === true) {
    //             t += (row.tray_freight_cost * row.OrderdQty);
    //         }
    //     })
    //     return t;
    // }, [visibleRows, rows]);

    // React.useEffect(() => {
    //     if (filterFormData !== undefined && filterFormData !== null && filterFormData['delivery_number'] !== undefined && filterFormData['delivery_number'] !== null) {
    //         console.log("filtering: " + filterFormData['delivery_number']);
    //         setRows(unfilteredRows.filter((r: any) => {
    //             return r.deliveryHeaderId.indexOf(filterFormData['delivery_number']) === 0;
    //         }));
    //     }
    //     else {
    //         setRows(unfilteredRows);
    //     }
    // }, [unfilteredRows, filterFormData['delivery_number']]);

    // const panel = (<PanelView dataSource={rows} selectedDeliveries={selectionModel} setSelectedDeliveries={setSelectionModel} selectionModel={selectionModel} requestUpdate={loadLoads} />);

    function DetailPanelContent({ row: rowProp }: { row: IDeliveryHeader }) {
        let deliveryItems = rowProp.deliveryItems != null ? rowProp.deliveryItems : [];
        return (
            <Stack
                sx={{ py: 2, height: '100%', boxSizing: 'border-box' }}
                direction="column"
            >
                <Paper sx={{ flex: 1, p: 1 }}>
                    <Stack direction="column" spacing={1} sx={{ height: 1 }}>
                        <DataGridPro
                            density="compact"
                            checkboxSelection={true}
                            columns={[
                                {
                                    field: 'brokerMaterialNumber',
                                    headerName: 'Broker Material',
                                    width: 170
                                },
                                { field: 'materialDescription', headerName: 'Description', width: 250 },
                                {
                                    field: 'orderedQuantity',
                                    headerName: 'Ordered',
                                    type: 'number',
                                    valueGetter: ({ row }) => row.orderedQuantity, // * row.unitPrice
                                },
                                { field: 'unitOfMeasure', headerName: 'UOM', width: 50, align: 'center' },
                                { field: 'incomingType', headerName: 'Inc. Type', width: 75 },
                                { field: 'materialGroup', headerName: 'Tray Size', width: 80, align: 'center', valueGetter: ({ row }) => row.materialGroup?.substring(3), },
                                {
                                    field: 'scheduledShipDate', headerName: 'Schedule Ship Date', width: 150, align:'center', valueFormatter: params => {
                                        let date = moment(params?.value);
                                        if (date.isValid()) {
                                            return moment(params?.value).format("MM/DD/YYYY")
                                        } return "";
                                    }

                                },
                                {
                                    field: 'submitted', headerName: 'Submitted', width: 125, type: 'boolean', renderCell: (params) => {
                                        return params.value ? (
                                            <CheckIcon
                                                style={{
                                                    color: 'green',
                                                }}
                                            />
                                        ) : (
                                            <CloseIcon
                                                style={{
                                                    color: 'green',
                                                }}
                                            />
                                        );
                                    },
                                },
                            ]}
                            rows={deliveryItems}
                            sx={{ flex: 1 }}
                            hideFooter
                        />
                    </Stack>
                </Paper>
            </Stack>
        );
    }

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#89B219',
            },
        },
    });

    const [searchInformation, setSearchInformation] = React.useState<ISearchChips>();

    const handleSearchChips = (searchInformation: ISearchChips) => {
        setSearchInformation(searchInformation);
    }

    function RouteClicked(_event: React.MouseEvent<HTMLElement>): void {
        // openRouteManager();
    }

    const buttons = [
        <ActionButton action={RouteClicked} buttonLabel="DOWNLOAD REPORT" />,
        <ActionButton action={RouteClicked} buttonLabel="UPDATE STATUS" />,
    ];

    const [selectionModel, setSelectionModel] = React.useState<any>([]);

    const [deliveries, setDeliveries] = React.useState<IDeliveryHeader[]>([]);
    const [total, setTotal] = React.useState<number>(0);

    React.useEffect(() => {
        loadLoads().then();
    }, [searchInformation?.weeks, searchInformation?.year]);

    const loadLoads = async function () {
        console.log("IN LOADING");
        setDeliveries([]);
        //We only get loads based on the week and year as it would be heavy to get all of them, all the time
        try {
            if (!searchInformation) {
                setDeliveries([]);
                return;
            }
            let year = searchInformation.year;
            for (const week of searchInformation.weeks) {
                await axios.get<IDeliveryHeader[]>(`${process.env.REACT_APP_ENDPOINT}/api/DeliveryHeaders/invoicing/${week.weekNumber}/${year}`).then((resp) => {
                    setDeliveries(existingRows => [...existingRows, ...resp.data])
                })
            }

            let tempTotal = 0.00;
            for (const delivery of deliveries) {
                let freightCost = delivery.trayFreightCost;
                let quantityOrdered = delivery.deliveryItems?.reduce((nextValue, currentValue) => nextValue + currentValue.orderedQuantity, 0)
                if (isNaN(freightCost) || quantityOrdered == undefined || isNaN(quantityOrdered)) {
                    continue;
                }
                tempTotal += freightCost * quantityOrdered;
            }

            setTotal(tempTotal);
        }
        catch (e) {
            console.log(e);
        }
    };

    // const getFilteredLoads = async () => {
    //     if (filterFormData === undefined || filterFormData['week_year'] === null || filterFormData['week_year'] === undefined || filterFormData['week_year'] === null || filterFormData['week_year'] === "") {
    //         setRows([]);
    //         return;
    //     }

    //     console.log("GetListOfPatchingToBeDoneFromServer");
    //     try {

    //         let outputRows: any[] = [];
    //         await filterFormData['week_year'].forEachAsync(async (weekObj: { week: any; year: any; }) => {
    //             console.log(weekObj);
    //             // const [year, week] = weekObj.split("-");
    //             //`${process.env.REACT_APP_ENDPOINT}/api/Crews`
    //             //const response = await axios.get(`/logistic/shippedDeliveries/week/${weekObj.week}/${weekObj.year}`);
    //             const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/DeliveryHeaders/${weekObj.week}/${weekObj.year}`);
    //             if (response.status === 200) {
    //                 // TODO: refresh the table on the main page? or location.reload
    //                 console.log(response);
    //                 outputRows = [...outputRows, ...response.data]
    //             }
    //         });
    //         return outputRows;
    //     } catch (err) {
    //         console.log(err);
    //         return [];
    //     }
    // }

    const getDetailPanelHeight = React.useCallback(() => 400, []);

    const getDetailPanelContent = React.useCallback<
        NonNullable<DataGridProProps['getDetailPanelContent']>
    >(({ row }) => <DetailPanelContent row={row} />, []);

    return (
        <Box component='div' height={'100vh'}>
            <ActionMenu buttons={buttons}></ActionMenu>
            <ThemeProvider theme={darkTheme}>
                <SearchChips handleSearch={handleSearchChips}></SearchChips>
            </ThemeProvider>
            <Grid container minHeight={'83%'}>
                <Grid xs={12} minHeight={'83%'}>
                    <DataGridPro
                        // apiRef={apiRef}
                        className={"DataGrid"}
                        // style={{"width": "100%", 'maxWidth': '100%', 'height': '100%'}}
                        rows={deliveries}
                        columns={[
                            {
                                field: 'submitted', headerName: 'Web Track', width: 150, editable: false,
                                renderCell: (cellValues: { row: { submitted: any; }; }) => {
                                    return (
                                        <div>
                                            <Chip label={cellValues.row.submitted ? "Submitted" : "Not Submitted"} style={{ backgroundColor: cellValues.row.submitted ? "green" : "black", width: '100%' }} />
                                        </div>
                                    );
                                }
                            },
                            { field: 'submittedAt', headerName: 'Submitted At', width: 200 },
                            { field: 'status', headerName: 'Status', width: 200 },
                            { field: 'brokerDeliveryId', headerName: 'Delivery #', width: 200 }, //BrokerDeliveryID?
                            { field: 'orderedQuantity', headerName: '# of Trays', width: 200 },
                            // {
                            //     field: 'number_of_trays_sent', headerName: 'Shipped Trays', width: 200, editable: true,
                            //     renderCell: (cellValues: { row: { number_of_trays: number; number_of_trays_sent: any; }; }) => {
                            //         return (<span style={{ color: Math.abs(cellValues.row.number_of_trays - cellValues.row.number_of_trays_sent) > 0 ? "red" : "black" }} >{cellValues.row.number_of_trays_sent}</span>);
                            //     }
                            // },
                            { field: 'soldToName', headerName: 'Customer Name', width: 200 },
                            { field: 'materialDescription', headerName: 'Description', width: 200 },
                            { field: 'brokerMaterialNumber', headerName: 'Material Number', width: 200 },
                            { field: 'shipMethodDesc', headerName: 'Planned Ship Type', width: 200 },
                            // {
                            //     field: 'actualShipType', headerName: 'Ship Type', width: 200,
                            //     renderCell: (cellValues: { row: { projected_ship_type: any; actual_ship_type: any; }; }) => {
                            //         return (<span style={{ color: cellValues.row.projected_ship_type !== cellValues.row.actual_ship_type ? "red" : "black" }} >{cellValues.row.actualShipType}</span>);
                            //     }
                            // },
                            { field: 'boxCharge', headerName: 'Box Charge', width: 200 },
                            // {
                            //     field: 'tray_freight_cost_default', headerName: 'Tray Freight Cost', width: 200,
                            //     renderCell: (cellValues: any) => {
                            //         // let fc = getLocationDefaultTrayFreightCost(cellValues)
                            //         // return (<span>{fc}</span>);
                            //     }
                            // },
                            // {
                            //     field: 'trayFreightCost', headerName: 'Adjusted TFC', width: 200,
                            //     renderCell: (cellValues: any) => {
                            //         // let fc = getLocationDefaultTrayFreightCost(cellValues)
                            //         // return (<span style={{ color: cellValues.row.tray_freight_cost !== fc ? "red" : "black" }} >{cellValues.row.tray_freight_cost}</span>);
                            //     }
                            // },
                            // {
                            //     field: 'shipCost', headerName: 'Planned Ship Cost', width: 200,
                            //     valueGetter: (cellValues: any) => {
                            //         console.log(cellValues);
                            //         // try {
                            //         //     return new Intl.NumberFormat('en-US', {
                            //         //         style: 'currency',
                            //         //         currency: 'USD'
                            //         //     }).format(getLocationDefaultTrayFreightCost(cellValues) * cellValues.row.OrderdQty)
                            //         // } catch (e) {
                            //         //     return new Intl.NumberFormat('en-US', {
                            //         //         style: 'currency',
                            //         //         currency: 'USD'
                            //         //     }).format(0);
                            //         // }
                            //     }
                            // },
                            // {
                            //     field: 'actualShipCost', headerName: 'Adjusted Ship Cost', width: 200,
                            //     valueGetter: ({row}) => {
                            //         try {
                            //             return new Intl.NumberFormat('en-US', {
                            //                 style: 'currency',
                            //                 currency: 'USD'
                            //             }).format(row.trayFreightCost * row.)
                            //         } catch (e) {
                            //             return new Intl.NumberFormat('en-US', {
                            //                 style: 'currency',
                            //                 currency: 'USD'
                            //             }).format(0);
                            //         }
                            //     }
                            // },
                        ]}
                        rowsPerPageOptions={[5, 10]}
                        checkboxSelection={true}
                        disableSelectionOnClick
                        selectionModel={selectionModel}
                        onSelectionModelChange={(x) => setSelectionModel(x)}
                        pagination={true}
                        sx={{ minHeight: '90%' }}
                        getDetailPanelContent={getDetailPanelContent}
                        getDetailPanelHeight={getDetailPanelHeight}
                    />
                </Grid>
            </Grid>
            <ThemeProvider theme={darkTheme}>
                <Grid container bgcolor="#101010">
                    <Grid xs={12} sx={{ paddingTop: '10px', paddingBottom: '10px' }}>
                        <TextField fullWidth={true} color='primary' variant='outlined' value={new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)} label={"FREIGHT COST TOTAL"} />
                    </Grid>
                </Grid>
            </ThemeProvider>

        </Box>


    )
}
